import LBTPDT from '../assets/images/thumbnails/LBTPDT.png'
import LBTPD from '../assets/images/preview/LBTPD.png'
import QPCLBT from '../assets/images/thumbnails/QPCLBT.png'
import QPCLBP from '../assets/images/preview/QPCLBP.png'
import CreepyLogo from '../assets/images/logo/LogoCreepy.png'
import DMB85T from '../assets/images/thumbnails/DMB85T.png'
import DMB105T from '../assets/images/thumbnails/DMB105T.jpg'
import DMBLogo from '../assets/images/logo/LogoDMB.png'
import PD6T from '../assets/images/thumbnails/PD6T.jpg'
import PDLogo from '../assets/images/logo/LogoPD.png'
import Creepy5T from '../assets/images/thumbnails/Creepy5T.jpg'
import PD7T from '../assets/images/thumbnails/PD7T.png'
import PD7TP from '../assets/images/thumbnails/PD7T.png'
import PD8T from '../assets/images/thumbnails/PD8T.png'
import ENTRETT from '../assets/images/thumbnails/ENTRETT.png'
import JATR from '../assets/images/thumbnails/JAT.png'
import LBTPDT2 from '../assets/images/thumbnails/LBTPDTT.png'
import DOM from '../assets/images/thumbnails/DOMINO.jpg'


import TMDLOGO from '../assets/images/logo/logotmd.jpg'

const Lost = [
    {
        id: 1,
        section: 'Lost',
        title: '666lego/%bob..o#3# | ¿Te parece Divertido?',
        thumbnailUrl: LBTPDT,
        webUrl: 'https://www.youtube.com/embed/MSyvggKKpkA', // Add the episode URL
        backgroundImage: LBTPD,
        seriesLogo: CreepyLogo,
        description: '???',
      },
      {
        id: 2,
        section: 'Lost',
        title: '29 de Febrero...wiiiii!',
        thumbnailUrl: DOM,
        webUrl: 'https://www.youtube.com/embed/Ety6CbFc8g0', // Add the episode URL
        backgroundImage: DOM,
        seriesLogo: TMDLOGO,
        description: 'Veamos si mi cuenta dura para el 29 de Febrero de 2016! :D',
      },
      {
        id: 3,
        section: 'Lost',
        title: '¿Qué Pasó con LegoBob?',
        thumbnailUrl: QPCLBT,
        webUrl: 'https://www.youtube.com/embed/_2RTvKCSQ3A', // Add the episode URL
        backgroundImage: QPCLBP,
        seriesLogo: TMDLOGO,
        description: '???',
      },
      {
        id: 4,
        section: 'Lost',
        title: 'Teaser - Duper Mario Bros Ep 8.5 (Escena Eliminada)',
        thumbnailUrl: DMB85T,
        webUrl: 'https://www.youtube.com/embed/9bQTVVjycak', // Add the episode URL
        backgroundImage: DMB85T,
        seriesLogo: DMBLogo,
        description: 'La escena sale el viernes 22 de Septiembre!!',
      },
      {
        id: 5,
        section: 'Lost',
        title: 'Trailer Creepypasta - TheMarioDimension2',
        thumbnailUrl: Creepy5T,
        webUrl: 'https://www.youtube.com/embed/g9NBs8cA-1w', // Add the episode URL
        backgroundImage: Creepy5T,
        seriesLogo: CreepyLogo,
        description: '???',
      },
      {
        id: 6,
        section: 'Lost',
        title: '(Trailer) Duper Mario Bros - Episodio 10.5',
        thumbnailUrl: DMB105T,
        webUrl: 'https://www.youtube.com/embed/Webe64LLrX8', // Add the episode URL
        backgroundImage: DMB105T,
        seriesLogo: DMBLogo,
        description: 'Video deslistado en el canal',
      },
      {
        id: 7,
        section: 'Lost',
        title: 'Teaser - Preguntas Dimensionales #6',
        thumbnailUrl: PD6T,
        webUrl: 'https://www.youtube.com/embed/YwNAODkDPtA', // Add the episode URL
        backgroundImage: PD6T,
        seriesLogo: PDLogo,
        description: 'Visuales (Ezlo):  @TomySiete',
      },
      {
        id: 8,
        section: 'Lost',
        title: 'Teaser - Preguntas Dimensionales #7',
        thumbnailUrl: PD7T,
        webUrl: 'https://www.youtube.com/embed/lTcgm2u0dDk', // Add the episode URL
        backgroundImage: PD7TP,
        seriesLogo: PDLogo,
        description: 'Si ves esto eres cool.',
      },
      {
        id: 9,
        section: 'Lost',
        title: 'EL REGRESO || PROXIMAMENTE',
        thumbnailUrl: ENTRETT,
        webUrl: 'https://www.youtube.com/embed/ylEsY96JSug', // Add the episode URL
        backgroundImage: ENTRETT,
        seriesLogo: PDLogo,
        description: 'Rodrigo regresa a contarnos su versión. Desde sus inicios en YouTube, hasta lo que ha estado haciendo estos últimos años. Esperen la entrevista proximamente!! Esto se logró gracias a todos ustedes!!',
      },
      {
        id: 10,
        section: 'Lost',
        title: 'Teaser - Preguntas Dimensionales #8',
        thumbnailUrl: PD8T,
        webUrl: 'https://www.youtube.com/embed/ky46r3O4BGM', // Add the episode URL
        backgroundImage: PD8T,
        seriesLogo: PDLogo,
        description: 'Si lees esto eres chido.',
      },
      {
        id: 11,
        section: 'Lost',
        title: 'Trailer Jueguemos a...',
        thumbnailUrl: JATR,
        webUrl: 'https://www.youtube.com/embed/-ILKPBGIeFE', // Add the episode URL
        backgroundImage: JATR,
        seriesLogo: PDLogo,
        description: 'Si ves esto escribe "pollo" en los comentarios...',
      },
      {
        id: 12,
        section: 'Lost',
        title: 'Teaser - ¿Te Parece Divertido?',
        thumbnailUrl: LBTPDT2,
        webUrl: 'https://www.youtube.com/embed/Qm45_7HChKM', // Add the episode URL
        backgroundImage: LBTPDT2,
        seriesLogo: CreepyLogo,
        description: 'Algo aterrador se acerca...',
      },
  ];

  export default Lost;
